import React, { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';

const TextInput = ({
  label,
  value,
  onChange,
  placeholder = 'Enter value...',
  customClass,
  type = 'text', // 'text' | 'number'
}) => {
    const [inputValue, setInputValue] = useState(value || '');
    const [error, setError] = useState('');

    useEffect(() => {
    setInputValue(value || '');
    }, [value]);

    const handleChange = (e) => {
    const val = e.target.value;

    if (type === 'number' && val && !/^\d*$/.test(val)) return;

    setInputValue(val);
    onChange(val);

    };

  return (
    <div className={`w-1/3 ${customClass}`}>
      {label && <label className="w-fit form-label mb-1">{label}</label>}
      <input
        type={type}
        value={inputValue}
        onChange={handleChange}
        placeholder={placeholder}
        className={cn(
          'input no-spinner',
          error ? 'border-red-500' : 'border-gray-300'
        )}
      />
    </div>
  );
};

export { TextInput };
